"use client";

import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { Pagination } from "./pagination";

interface PaginationNavProps {
  page: number;
  totalPages: number;
}

export function PaginationNav({ page, totalPages }: PaginationNavProps) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handlePageChange = (newPage: number) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("page", String(newPage));
    router.push(`${pathname}?${params.toString()}`);
  };

  return <Pagination page={page} totalPages={totalPages} onPageChange={handlePageChange} />;
}
